//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters("yunMobile", {
      data: "getData"
    })
  },
  methods: {
    ...mapActions("yunMobile", {
      setCarin: "setCarinAction"
    }),
    linkToPay() {
      if (this.data.ishave == 1) {
        this.$store.commit("yunMobile/setCarin", this.data);
        this.$router.push({ path: `/mobile/yunMobile/confirmPay/1` });
      } else {
        this.setCarin({
          parkNo: this.data.parkNo,
          mediaNo: this.$route.params.carNo,
          tdid: this.data.tdid,
          inputTime: this.data.intime,
          busNo: this.data.business,
          disMoney: this.data.discount,
          disAutoNo: this.data.discountNo
        }).then(() => {
          // sessionStorage.setItem('carNo',this.$route.params.carNo)
          this.$router.push({ path: `/mobile/yunMobile/confirmPay/1` });
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/confirmMsg.vue